export const variants = [
  {
    props: { tone: "Secondary" },
    style: ({ theme }) => ({
      minHeight: 1,
      "& .MuiTabs-indicator": {
        backgroundColor: theme.palette.border.indicator,
      },
    }),
  },
];
